"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
exports.__esModule = true;
exports.requestApply = void 0;
var isClient_1 = __importDefault(require("../shared/isClient"));
var RequestApplyEnum;
(function (RequestApplyEnum) {
  RequestApplyEnum[RequestApplyEnum["onError"] = 0] = "onError";
  RequestApplyEnum[RequestApplyEnum["onSuccess"] = 1] = "onSuccess";
  RequestApplyEnum[RequestApplyEnum["config"] = 2] = "config";
})(RequestApplyEnum || (RequestApplyEnum = {}));
var Singleton = /** @class */function () {
  function Singleton() {
    this.events = new Map();
    this.config = {};
    this.allowedEventKeys = new Set();
    if (!Singleton.instance) {
      Singleton.instance = this;
    }
    this.allowedEventKeys = new Set(Object.keys(RequestApplyEnum).filter(function (k) {
      return isNaN(Number(k)) && k.startsWith('on');
    }));
    return Singleton.instance;
  }
  Singleton.prototype.onSuccess = function (cb) {
    this.events.set('onSuccess', cb);
  };
  Singleton.prototype.onError = function (cb) {
    this.events.set('onError', cb);
  };
  Singleton.prototype.setConfig = function (opts, replaced) {
    if (opts === void 0) {
      opts = {};
    }
    if (replaced) {
      this.config = opts;
    } else {
      this.config = __assign(__assign({}, this.config), opts);
    }
  };
  Singleton.prototype.setPayload = function (payload) {
    var _a;
    this.config.payload = __assign(__assign({}, (_a = this.config.payload) !== null && _a !== void 0 ? _a : {}), payload);
  };
  Singleton.prototype.getGlobal = function () {
    var globalOptions = {
      config: this.config
    };
    this.events.forEach(function (value, key) {
      globalOptions[key] = value;
    });
    return globalOptions;
  };
  Singleton.prototype.hasEventKey = function (prop) {
    return this.allowedEventKeys.has(prop);
  };
  return Singleton;
}();
// 以下是创建全局实例
var requestApplySymbol = '__CARGO_REQUEST_HOOK__';
var singleton;
function requestApply(opts) {
  if (!isClient_1["default"]) return;
  if (!(requestApplySymbol in window)) {
    singleton = new Singleton();
    Object.defineProperty(window, requestApplySymbol, {
      get: function get() {
        return singleton;
      },
      set: function set() {
        throw "".concat(requestApplySymbol, " is prohibit");
      }
    });
  }
  singleton = window[requestApplySymbol];
  if (opts) {
    for (var prop in opts) {
      if (singleton.hasEventKey(prop)) {
        // @ts-ignore
        singleton.events.set(prop, opts[prop]);
      } else if (prop === 'config') {
        singleton.setConfig(opts.config, true);
      }
    }
  }
  return singleton;
}
exports.requestApply = requestApply;